module.exports = __webpack_public_path__ + "static/media/logosmall.5d1aeb5c.svg";